import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { IconImg } from '../../Defaults/Icon/IconImg';
import {
  FlexRowCenter,
  FlexRowCenterVertical,
  FlexCol,
  FlexColCenter,
} from '../../Defaults/Flexbox/Flexbox';
import { Icon } from '../../Defaults/Defaults';
import { DsiSvgIcon } from '../General/SvgIcon';
import { DsiIconType } from '../../..';

interface Props {
  text: any;
}

function PriceTooltip({ text }: Props) {
  const [popupVisiblity, setPopupVisiblity] = React.useState(false);
  const handleMouseOver = () => {
    setPopupVisiblity(true);
  };

  const handleMouseLeave = () => {
    setPopupVisiblity(false);
  };

  return (
    <Wrapper>
      <DsiSvgIcon
        onClick={handleMouseOver}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
        icon={DsiIconType.info}
        width={20}
        height={20}
        fill={'#CCCCCC'}
        // title={`${__('Priemerná cena')}`}
      />

      <AbsoluteWrapper>
        <PopUpContainer show={popupVisiblity}>
          <PopUpValidationMessage>
            <Stores>{text}</Stores>
          </PopUpValidationMessage>
          <ArrowIcon>
            <Icon
              fill={'rgba(65, 65, 65, 0.88)'}
              src={'/assets/dsi/arrow-triangle-gray.svg'}
            />
          </ArrowIcon>
        </PopUpContainer>
      </AbsoluteWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  position: relative;
`;

const Stores = styled(FlexCol)`
  padding: ${rem(8)};
`;

const AbsoluteWrapper = styled.div`
  position: absolute;
`;

const PopUpContainer: any = styled(FlexColCenter)<{ moveLeft?: boolean }>`
  position: absolute;
  color: #fff;
  opacity: ${(props: any) => (props.show ? 1 : 0)};
  visibility: ${(props: any) => (props.show ? 'visible' : 'hidden')};
  transition: opacity 0.6s;
  transform: ${({ moveLeft }) => (moveLeft ? 'translateY(-50%)' : 'none')};
  top: ${({ moveLeft }) => (moveLeft ? '10px' : 'unset')};
  right: ${({ moveLeft }) => (moveLeft ? 'calc(100% - 12px)' : 'unset')};
  left: ${({ moveLeft }) => (moveLeft ? 'unset' : '-64px')};
  bottom: ${({ moveLeft }) => (moveLeft ? 'unset' : 0)};
  z-index: 50;
  flex-flow: ${({ moveLeft }) => (moveLeft ? 'row' : 'column')};
`;

const PopUpValidationMessage = styled(FlexRowCenter)`
  width: 100%;
  /* width: ${rem(150)}; */
  /* min-height: ${rem(35)}; */
  /* padding: ${rem(6)} ${rem(11)}; */
  background: rgba(65, 65, 65, 0.88);
  border-radius: ${rem(4)};
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.tertiary};
  white-space: nowrap;
`;

const ArrowIcon = styled(FlexRowCenter)<{ moveLeft?: boolean }>`
  width: ${rem(7)};
  height: ${rem(7)};
  position: relative;
  transform: ${({ moveLeft }) => (moveLeft ? 'rotate(270deg)' : 'none')};
  right: ${({ moveLeft }) => (moveLeft ? rem(3.2) : 'unset')};
  top: ${({ moveLeft }) => (moveLeft ? 'unset' : '-2px')};
`;

export { PriceTooltip };
